import { BaseService } from './base.service'
var querystring = require('querystring');

export class TicketsService extends BaseService {

  static async getAirportlist() {
    try {
      const response = await this.ticketRequest({ auth: true }).get(`/api/WebService/Airportlist`);

      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  static async getAvaibles(from,to,date='2022-12-20') {
    try {
      const response = await this.ticketRequest({ auth: true }).post(`/api/WebService/Available`,{
        from_flight : from,
          to_flight : to,
          date_flight : date
      });

      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  static async getAvaibles15Days(from,to) {
    try {
      const response = await this.ticketRequest({ auth: true }).post(`/api/WebService/Available15Days`,{
        from_flight : from,
          to_flight : to,
      });

      return response.data
    } catch (error) {
      console.log(error)
    }
  }


  static async captcha(data) {
      try {
          if( typeof data.selectedTicket === 'undefined' ) return false;
        let selectedTicket = data.selectedTicket

          const response = await this.ticketRequest({ auth: true }).post(`/api/WebService/GetCaptcha`,{
              from_flight: selectedTicket.from.toUpperCase(),
              to_flight: selectedTicket.to.toUpperCase(),
              date_flight: selectedTicket.date_flight,
              time_flight: selectedTicket.time_flight,
              number_flight: selectedTicket.number_flight,
              ajency_online_ID: selectedTicket.ajency_online_ID,
              cabinclass: selectedTicket.cabinclass,
              airline: selectedTicket.airline
          });

          return response.data
      } catch (error) {
          console.log(error)
      }
  }

  static async pay(data) {
      try {
          if( typeof data.captcha === 'undefined' || typeof data.userInfo === 'undefined' || typeof data.selectedTicket === 'undefined' ) return false;
        let userInfo = data.userInfo;
        let selectedTicket = data.selectedTicket
        let captcha = data.captcha

          let passengers = []
          let email=''
          let mobile =''

          for ( let i=1;i<=Object.keys(userInfo).length;i++){
              let v = userInfo[i]
              passengers.push({
                  passengerType: v.passenger_type,
                  fnamefa: v.fa_name,
                  lnamefa: v.fa_family,
                  fnameen: v.en_name,
                  lnameen: v.en_family,
                  gender: v.sex,
                  nationality: ( v.type === 'PASSPORT' ? 0 : 1 ),
                  passengerCode: ( v.type === 'PASSPORT' ? v.passport_number : v.national_code ),
                  nationalitycode: 'IRI' ,
                  expdate: ( v.type === 'PASSPORT' ? v.passport_exp : '' ),
                  birthday: ( v.type === 'PASSPORT' ? v.birthday_date : v.birth_day )
              })
              if( !email && v.email ) email = v.email
              if( !mobile && v.mobile ) mobile = v.mobile
          }

          const response = await this.ticketRequest({ auth: true }).post(`/api/WebService/Reservation`,{
              id_request: captcha.id_request,
                  captchcode: captcha.captcha_text,
              mobile: mobile,
              email: email,
              passengers: passengers
          });

          return response.data
      } catch (error) {
          console.log(error)
      }
  }

  static async final_pay(data) {
      try {
          if( typeof data.id_request === 'undefined' || typeof data.id_faktor === 'undefined' || typeof data.totalprice_request === 'undefined' ) return false;
        let id_request = data.id_request;
        let id_faktor = data.id_faktor
        let totalprice_request = data.totalprice_request

          const response = await this.ticketRequest({ auth: true }).post(`/api/WebService/PayAndBuyTicket`,{
              "id_request": id_request,
              "id_faktor": id_faktor,
              "price": totalprice_request,
              "redirectURL": "http://localhost:8080/callback"
          });

          return response.data
      } catch (error) {
          console.log(error)
      }
  }
}
